import { BaseDto } from './base.dto';

export class Contact extends BaseDto {
  name: string;
  email?: string;
  mobileNumber?: string;
  phoneNumber?: string;
  extraEmail?: string;
  jobTitle?: string;
}
